import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "_tc--light" }
const _hoisted_2 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_title = _resolveComponent("base-title")
  const _component_tooltip = _resolveComponent("tooltip")

  return (_openBlock(), _createElementBlock("div", null, [
    ($props.title)
      ? (_openBlock(), _createBlock(_component_base_title, {
          key: 0,
          level: "h3",
          class: "_pa-2"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($props.title), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.navigationItems, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.name,
        class: _normalizeClass(['_flex _pa-2 _ai-c _jc-fs gfu-link-underline _bl-3 _pos-r', {'_bc--accent': item.isActive}])
      }, [
        (item.isRestricted)
          ? (_openBlock(), _createBlock(_component_tooltip, {
              key: 0,
              text: item.restrictionReason,
              "vertical-position": "down"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_1, _toDisplayString(item.name), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["text"]))
          : (_openBlock(), _createElementBlock("a", {
              key: item.name,
              href: item.url
            }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_2))
      ], 2 /* CLASS */))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}